<div class="filter-component">
  <h5 class="filter-heading mb-3">{{ 'SORT_BY' | translate }}</h5>
  <select id="selectOrdering" class="form-select mb-4" [(ngModel)]="selectedSort" (change)="onFilterChange()">
    <option selected value="">{{ 'DEFAULT' | translate }}</option>
    <option value="NAME_ASC">{{ 'NAME_ASC' | translate }}</option>
    <option value="NAME_DESC">{{ 'NAME_DESC' | translate }}</option>
    <option value="PRICE_ASC">{{ 'PRICE_ASC' | translate }}</option>
    <option value="PRICE_DESC">{{ 'PRICE_DESC' | translate }}</option>
  </select>

  <h6 class="filter-label">{{ 'COLOR' | translate }}</h6>
  <div class="d-flex flex-wrap gap-2 mb-3">
    <span
      *ngFor="let color of colors"
      class="color-circle"
      [ngStyle]="{
        background: color,
        border: selectedColors.includes(color) ? '2px solid #333' : '1px solid #ccc'
      }"
      (click)="onColorClick(color)"
    ></span>
  </div>

  <h6 class="filter-label">{{ 'SIZE' | translate }}</h6>
  <div class="form-check mb-2" *ngFor="let size of sizes">
    <input
      type="checkbox"
      class="form-check-input"
      [id]="size"
      [checked]="selectedSizes.includes(size)"
      (change)="onSizeToggle(size)"
    />
    <label class="form-check-label ms-2" [for]="size">{{ size }}</label>
  </div>

  <h6 class="filter-label mt-3">{{ 'TYPE' | translate }}</h6>
  <div class="form-check mb-2" *ngFor="let category of categories">
    <input
      class="form-check-input"
      type="radio"
      name="category"
      [id]="category.name"
      [value]="category.name"
      [(ngModel)]="selectedCategory"
      (change)="onFilterChange()"
    />
    <label class="form-check-label ms-2" [for]="category.name">{{ category.name }}</label>
  </div>

  <button class="btn btn-outline-secondary w-100 mt-4" (click)="clearFilters()">
    {{ 'CLEAR_FILTERS' | translate }}
  </button>
</div>
